/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Underdevelopment1Inputs */

const en_underdevelopment1 = /** @type {(inputs: Underdevelopment1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Under Dev`)
};

const de_underdevelopment1 = /** @type {(inputs: Underdevelopment1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Entwicklung`)
};

/**
* | output |
* | --- |
* | "Under Dev" |
*
* @param {Underdevelopment1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const underdevelopment1 = /** @type {((inputs?: Underdevelopment1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Underdevelopment1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_underdevelopment1(inputs)
	return de_underdevelopment1(inputs)
});
export { underdevelopment1 as "underDevelopment" }